import { z } from 'zod'
import { iso8601DateSchema, stringSchema } from './common'

const venueSchema = z.object({
  name: stringSchema.nullish(),
  description: stringSchema.nullish(),
  address: stringSchema.nullish(),
  externalId: z.number().nullish(),
  googleMapsLink: stringSchema.nullish(),
  stadiumImage: stringSchema.nullish(),
  seatWidgetId: stringSchema.nullish(),
})

const competitionSchema = z.object({
  id: stringSchema.min(1),
  name: stringSchema.min(1),
})

export const searchSchema = z.object({
  type: z.enum(['product', 'page']),
  data: z.object({
    id: stringSchema.min(1),
    type: stringSchema.nullish(),
    image: stringSchema.nullish(),
    path: stringSchema.min(1),
    title: stringSchema.min(1),
    description: stringSchema.nullish(),
    startPrice: z.number().nullish(),
    startDate: iso8601DateSchema.nullish(),
    startTime: stringSchema.nullish(),
    endDate: iso8601DateSchema.nullish(),
    endTime: stringSchema.nullish(),
    venue: venueSchema,
    favourited: stringSchema.nullish(),
  }),
  competitions: z.array(competitionSchema).nullish(),
})
